module.exports = __webpack_public_path__ + "static/media/CountersScreen.33c0a9ce.png";